import { z } from 'zod';

import { AdvisorParticipantZod } from 'types/zod/advisor-participant';
import { ParticipantZod } from 'types/zod/participant';
import { SummaryParticipantZod } from 'types/zod/summary-participant';

const SummaryWithoutIncludesZod = z.object({
    advisors: z.array(AdvisorParticipantZod),
    originator: ParticipantZod,
    participants: z.array(SummaryParticipantZod),
    q: z.any(),
    q_instance_id: z.number(),
    q_state_code: z.string(),
    q_state_name: z.string(),
    q_type: z.string(),
    spouse: ParticipantZod.optional(),

    parent_host: z.string().optional(),
    section: z.string().optional(),
    is_payed: z.boolean().optional(),
});

export type Summary = z.infer<typeof SummaryWithoutIncludesZod> & {
    includes?: Summary[];
};

export const SummaryZod: z.ZodType<Summary> = SummaryWithoutIncludesZod.extend({
    includes: z.lazy(() => SummaryZod.array()).optional(),
});
